import React from 'react'
import { Table } from '../components/ui/Table'
import { time } from '../util/formatters'
import { useSelector } from 'react-redux'
import { axiosGet } from '../util/api'
import { differenceInMinutes, parseISO } from 'date-fns'
import { Filters } from '../config'
import { Layout } from '../components/Layout'
import { UpdateStatusBadge } from '../components/badge/UpdateStatusBadge'
import { State } from '../reducers'
import Update = Models.Update
import { Column } from '../types/table'
import type { EntityId } from '../types/constants'

export const Updates = () => {
    const profile = useSelector<State, EntityId | null>((state) => state.user.profile)
    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return axiosGet('updates', params)
    }

    const columns: Column<Update, any>[] = [
        { key: 'status_id', title: 'Status', cell: UpdateStatusBadge },
        { key: 'created_at', title: 'Started', formatter: time },
        { key: 'updated_at', title: 'Finished', formatter: time },
        {
            key: 'run_time',
            title: 'Run Time',
            cell: (v: Update) => {
                const start = parseISO(v.created_at)
                const end = parseISO(v.updated_at)
                const diff = differenceInMinutes(end, start)

                if (!diff) {
                    return '-'
                }

                return `${diff} mins`
            },
        },
    ]

    const filters = [Filters.UpdateStatus]

    return (
        <Layout primary="Updates">
            <Table
                name={'Updates'}
                showHeader={false}
                load={load}
                filters={filters}
                dateSelect
                columns={columns}
                onSelectChange={() => {}}
            />
        </Layout>
    )
}
